import { render, staticRenderFns } from "./createClinic.vue?vue&type=template&id=1baa84f6&scoped=true&"
import script from "./createClinic.vue?vue&type=script&lang=js&"
export * from "./createClinic.vue?vue&type=script&lang=js&"
import style0 from "./createClinic.vue?vue&type=style&index=0&id=1baa84f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa84f6",
  null
  
)

export default component.exports